import { NarrativeMiniValuatorCompanySearch } from './NarrativeMiniValuatorCompanySearch';
import { NarrativeMiniValuatorTrendingCompanies } from './NarrativeMiniValuatorTrendingCompanies';

type Props = {
  onCompanySelect: (canonicalUrl: string) => void;
};

export const NarrativeMiniValuatorCompanySelect = ({
  onCompanySelect,
}: Props) => {
  return (
    <div className="grid gap-x1 p-x2">
      <h3 className="m-0 text-xs font-normal">Value any company in seconds</h3>

      <NarrativeMiniValuatorCompanySearch onCompanySelect={onCompanySelect} />

      <h4 className="m-0 mt-x1 text-xs font-normal">Popular companies</h4>
      <NarrativeMiniValuatorTrendingCompanies
        onCompanySelect={onCompanySelect}
      />
    </div>
  );
};
